const lan = {
  REDIRECT: "הפניה מחדש...",
  RULE: {
    SERVICE_TYPE: "אנא בחר את סוג השירות ",
    COUNTRY: "אנא בחר את המדינה או האזור שלך",
    USERNAME: "יש להזין את שם המשתמש ",
    EMAIL: "יש צורך במייל",
    EMAIL2: "אנא הזן את פורמט האימייל הנכון.",
    PRODUCT: "אנא בחר את מוצרך ",
    PRODUCTSN: "אנא הזן את המספר הסידורי של המוצרך",
    PRODUCTSN_LEN: "נא להזין 12 עד 15 אותיות או מספרים",
    BIRTHDAY: "אנא הזן את תאריך הלידה שלך ",
    REQUIRED: "נדרש",
  },
  SYS: {
    HEAD: "מערכת",
    NOSERVICE: "מצטערים, ASUS Chat עבור המדינה או האזור שבחרת אינו זמין.",
    CHECK_FILESIZE: "אנא בדוק את גודל התמונה או הקובץ המצורף. לְהַגבִּיל:",
    RECONNECTED: "מצב החיבור חזר לקדמותו",
    UNABLE_SEND: "לא ניתן לשלוח את הקבצים המצורפים",
    NO_NETWORK: "אין חיבור אינטרנט",
    NO_NETWORK_INFO: "אין חיבור אינטרנט. אנא התחבר מחדש לאינטרנט ונסה שוב.",
  },
  IDLE: {
    HEAD: "לא התקבלה תגובה כבר זמן מה . האם להשאיר אותך מחובר ?",
    BUTTON: "המשך",
  },
  DISCONNECT: {
    HEAD: "הצ'אט הסתיים",
    BUTTON: "סיים",
  },
  LAYOUT: {
    STEP_1: "בחירת מוצר ",
    STEP_2: "תנאים והגבלות",
    STEP_3: "התחברות",
    STEP_4: "מידע",
    SELECT_SKILL: "בחירת מוצר ",
    PREV_STEP: "הקודם",
    NEXT_STEP: "הבא",
    NOTSET: "לא מסכים",
    AGREEN: "מסכים",
    NOTAGREEN: "לא מסכים",
    LEAVE: "עזוב",
    TYPE_HERE: "הקלד כאן ",
    CHAT_DOWNLOAD:
      "אנא לחץ כאן כדי לשמור עותק של הצ'אט שלך עם שירות הלקוחות המקוון של ASUS.",
  },
  COUNTRY: { SELECT_COUNTRY: "אנא בחר את המדינה או האזור של השירות" },
  POLICY: {
    PRIVACY: "מדיניות הגנת הפרטיות",
    SAT_SURVEY: "הסכם שירות",
    CONFIRM_COUNTRY: {
      H1: "לקוח ASUS יקר,",
      P1: 'אתה מבקר כעת בשירות הלקוחות המקוון של ASUS לאוסטרליה, השונה מהאזור הנוכחי שלך. על פי תנאי האחריות של ASUS, לא כל מוצר של ASUS חל על שירות אחריות ותמיכה בינלאומית של ASUS. אם האתר האזורי הנ"ל שבו אתה מבקר אינו האזור שבו קנית את מוצר ASUS שלך או שונה מהאזור הנוכחי שלך, זה עשוי להשפיע על זכויותיך. אתה יכול להמשיך להשתמש בשירות הלקוחות המקוון של ASUS עבור אוסטרליה או לשנות את שירות הלקוחות המקוון של ASUS לאזור שלך.',
      P2: "",
      P3: "",
      B1: "עבור ל-ASUS",
      B2: "אתר",
      B3: "המשך להשתמש",
    },
    BULLETIN: {
      HEAD: "הודעה על הודעה חשובה",
      CONFIRM: "הבנתי",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "אנא מלא את פרטי הקשר שלך",
    SURVEY_TYPE: "אנא בחר את סוג השירות",
    PROBLEM_BRIEF: "איך היית מתאר את הבעיה שלך?",
    TYPE1: "שאלה כללית",
    TYPE2: "שאלת תיקון מוצר ",
    TYPE3: "תמיכה טכנית",
    TYPE4: "בירור אחריות",
    TYPE5: "חוות דעת ומשוב",
    EC_TYPE1: "מידע עבור מוצר ומכירות",
    EC_TYPE2: "אירוע שיווקי",
    EC_TYPE3: "קנייה ומצב משלוח ",
    EC_TYPE4: "שירות החזרות",
    SIGNUPDATA: "פרטי הרישום שלך",
    NAME: "שם פרטי ",
    TEL: "מספר טלפון ",
    ORDER_NO: "Order No.",
    BIRTHDAY: "תאריך לידה",
    LABEL_EMAIL: "דואר אלקטרוני",
    EMAIL: "מייל",
    DEVICEINFO: "פרטי המוצר שלך ",
    DEVICENAME: "שם הדגם ",
    MY_DEVICE: "המוצר שלך ",
    MY_DEVICE_SELECT: "בחר את המוצר שלך",
    MY_DEVICE_EMPTY: "עדיין אין לך מכשירים.",
    LABEL_DEVICESN: "מספר סידורי",
    DEVICESN: "מספר סידורי של המוצר ",
    DEVICESN_ERROR: "המספר הסידורי שהזנת אינו תקין.",
    PREPARE: "יצירת חדר הצ'אט, מתכונן לצ'אט",
    START: "התחל את הצ'אט",
    AGE_LIMIT: "הגבלת גיל",
    AGE_LIMIT_DESC: "אינך עומד בדרישות הגיל כדי להשתמש ב-ASUS Chat",
    REPEAT_ENTRY: {
      H1: "זוהה חדר צ'אט קיים",
      P1: "האם אתה בטוח שאתה רוצה להתחיל שיחה חדשה? כאשר נפתחת שיחה חדשה, השיחה הישנה תסתיים.",
      B0: "אישור ",
      B1: "בטל ",
    },
  },
  CONNECTTING: {
    P1: "אנא המתן רגע, ואל תסגור את חלון הצ'אט",
    P2: "ASUS Chat מחבר אותך לסוכן זמין",
    NOTE: "רמז",
    BEFORE_LEAVE: "האם אתה בטוח שברצונך לסיים את הצ'אט של ASUS?",
    B0: "סיים",
    B1: "הישארו והמתינו",
  },
  OFFLIEN: {
    OTHER_CONTACT: "צור קשר עם ASUS דרך ערוצים אחרים",
    MAIL: "שלח לנו מייל",
    TEL: "התקשר אלינו",
    CLOSE: "סגור",
  },
  WAITTING: {
    WATTING_NUM: "מיקומך בתור ",
    PEOPLE: "לקוח",
    NOTE: "רמז",
    BEFORE_LEAVEL: "האם אתה בטוח שברצונך לצאת מהתור?",
    LEAVE_DESC: "אם אתה רוצה לצאת מהתור, אתה יכול לסיים את הצ'אט",
    LEAVE: "סיים את הצ'אט",
    STAY: "הישארו בתור",
  },
  CHATROOM: {
    TYPING: "הסוכן מקליד...",
    HEAD: {
      CLOSE_AMD_SURVEY: "סיים את הצ'אט",
      TERMINATE: "סיים את הצ'אט",
    },
    FOOTER: { CHAT_FINISH: "הצ'אט הסתיים" },
    FINISH: "הצ'אט הסתיים. האם אתה צריך שירות או תמיכה נוספים?",
    SAT_SURVEY: {
      SAT: "מרוצה",
      DISSAT: "לא מרוצה ",
      SAT_CHOOSE: "איזה סוג שירותים? (מרובות)",
      HEAD: "האם היית מרוצה משיחת מהצ'אט?",
      DESC: "הקשבה למשוב שלך היא כוח מניע לשיפור המתמיד שלנו. אנא הודע לנו אם יש לך הצעות לשירות או לתמיכה של ASUS.",
      OTHER_OPTION: "אחר",
      OTHER_REASON: "נא מלא את הסיבה האחרת",
      SEND: "שלח",
    },
    CLOSE: {
      TITLE: "האם אתה בטוח שאתה רוצה לסיים את הצ'אט?",
      P1: 'לחץ על "סיום" כדי לסגור את החלון. אם אתה צריך להשתמש שוב בצ\'אט, אנא לחץ על "התחל צ\'אט חדש".',
      B0: "סיים",
      B1: "בטל",
    },
  },
  ERROR: {
    H1: "חדר הצ'אט לא קיים או שהצ'אט כבר הסתיים",
    CLOSE: "סגור את החלון",
  },
  CHAT_END: {
    H1: "תודה רבה, הצ'אט הסתיים כעת",
    CLOSE: "סגור את החלון ",
  },
  CHAT_CLOSE: {
    H1: "הרשת שלך מושבתת במשך יותר מ-300 שניות, אז סגרנו את השיחה הזו.",
    DESC: "אם אתה משתמש ברשת אלחוטית או סלולרית, נא לעבור למיקום עם אות חזק יותר; או לעבור לחיבור רשת קווי. אנו מצטערים על אי הנוחות",
    CLOSE: "סגור את החלון ",
  },
  SURVEY_DONE: {
    H1: "תודה. השלמת את סקר שביעות הרצון מהשירות",
    P1: 'המשוב שלך הוא כוח מניע לשיפור המתמיד שלנו. תודה שהקדשת מזמנך כדי להשלים את סקר שביעות הרצון מהשירות. אם אתה זקוק לשירות או תמיכה נוספים, אנא לחץ על "התחל צ\'אט חדש". אנא לחץ על "סגור את החלון" כדי לסיים את הצ\'אט אם פתרנו את השאילתה שלך',
    AGAIN: "התחל צ'אט חדש ",
    CLOSE: "סגור את החלון ",
    YT_H1: "ASUS טיפים וידע טכנולוגי עם סרטוני התמיכה של ASUS.",
    YT_H2: "!חץ כדי לחקור!",
  },
  AGENT_OFFLINE: {
    H1: "חיבור האינטרנט של הסוכן אינו מגיב; הצ'אט שלך מופרע כרגע",
    H2: "נא לא לסגור את החלון; אנחנו עובדים קשה כדי לחדש את הצ'אט",
    DESC: "אתה יכול גם לבחור לסיים את הצ'אט ולהתחיל את הסקר או ללחוץ על \"התחל צ'אט חדש\", ואנו מיד נקצה סוכן חדש שימשיך את הצ'אט שלך. אנו מתנצלים על כל אי נוחות שקרתה",
    AGAIN: "התחל צ'אט חדש ",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "Unable to use camera and microphone",
    H1: "Ready to join?",
    P1: "In order for ASUS customer service staff to help you solve the problem more efficiently, you must allow the device to access your camera and microphone to join the video chat room, and please ensure that your mobile network connection is stable and functioning normally",
    P2: "After accessing, you can still freely set the lens switch and microphone mute.",
    VIDEO_STATE: "Video status",
    VIDEO_ON: "On",
    VIDEO_OFF: "Off",
    AUDIO_STATE: "Audio status",
    AUDIO_ON: "On",
    AUDIO_OFF: "Off",
    ENTER: "Join",
    HANGUP: {
      H1: "Hangup",
      P1: "Are you sure to hangup the viode chat?",
      CONFIRM: "Confirm",
      CANCEL: "Cancel",
    },
    END: {
      H1: "Video Call has ended",
      P1: "Thank you, this video chat is over, you can close this window.",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "Select Product",
      STEP_2: "Terms of Service",
      STEP_3: "Login",
      STEP_4: "Information",
      SELECT_SKILL: "Select Product",
      WELCOME: "ברוכים הבאים",
      AGREE: "מסכים",
      START: "התחלה",
      CANCEL: "ביטול",
      WAIT: "יש להמתין בבקשה",
      INPUT: "הזנת טקסט",
      TRANSFER_TOAGENT: "מעבר לנציג/ה.",
      READMORE: "ניתן לעיין גם בשאלות הנפוצות הקשורות הבאות, תודה לך.",
      COLLAPSE: "מוסתר",
      INPUT_SN: "אנא הזן שוב את מספר הסידורי",
      YOU_MAY_ALSO: "ייתכן גם שתרצה לשאול:",
      FOR_FURTHER: "למידע נוסף, אנא הפנה אל:",
      RECORDING: "התחל הקלטה...",
      RECORDING_NOT_SUPPORTED: "הדפדפן שלך אינו תומך בזיהוי דיבור",
      RECORDING_NOT_FOUND:
        "לא זוהה התקן הקלטה. אנא ודא שהמיקרופון מחובר ושהרשאות הגישה ניתנו.",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "סוג המוצר",
      MODEL: "שם המוצר",
      SERIALNO: "מספר סידורי של המוצר",
      STATUS: "מצב האחריות",
      DATE: "תאריך תפוגת האחריות",
    },
    HEAD: {
      LEAVE: "לעזוב",
      CREATE_NEW: "יצירת חדר חדש",
    },
    ENTRANCE: {
      POLICY: "מדיניות פרטיות",
      AGREE: "בכדי להתחיל את השיחה יש ללחוץ על מסכים",
    },
    MESSAGE: {
      WAIT: "נא להמתין בזמן שאנו מחפשים פתרון עבורך.",
    },
    END: "Conversation Ended",
    END_MSG: "השיחה הסתימה, שמחנו לתת לך שירות.",
    END_SURVEY: "סקר שביעות רצון",
    END_SURVEY_MSG: "השיחה הסתימה, שמחנו לתת לך שירות.",
    BACKHOME: "חזרה לעמוד הבית",
    SURVEY: {
      DESC: "נשמח לקבל ממך דירוג על חוויית השימוש עם העוזר הוירטואלי של ASUS.",
      SAT: "מרוצה",
      DISSAT: "לא מרוצה",
      FEEDBACK: "נודה לשיתוף חוות דעתך.",
      SEND: "שלח",
      BACK: "ביטול",
    },
    SURVEY_DISLIKE: {
      H1: "מדוע אינך מרוצה מהתשובה?",
      P: "המשוב שלך עוזר לנו לשפר את איכות השירות.",
      BUTTON: "שליחה",
    },
    HISTORY: {
      TITLE: "History",
      AGO: "{hours} שעות לפני",
      CONTINUE: "Continue Chat",
      CLOSE: "The conversation has been closed.",
      RESTART: "Restart with Virtual Assistant",
      NON_SERVICE: "Non-Service Hours",
      VIEW_HISTORY: "Click to view the latest chat history.",
    },
  },
};
export default lan;
